import React from 'react';
import { BookOpenIcon, CheckCircle2Icon, FileTextIcon, GiftIcon, TrophyIcon, XCircleIcon } from 'lucide-react';
const painPoints = ['Before every session you cannot recall the exact tool order, so you end up improvising.', 'You know how to do wood therapy, but not how to structure a 30, 45 or 60-minute session.', 'You always use the same protocol because you have no others documented.', 'A client asks how many sessions she needs and you cannot answer with confidence.', 'You own the wooden tools, but you do not use them all because you are unsure what each one is for.', 'Your clients improve, but they cannot see it, so they stop coming after two sessions.', 'You do not know how to build a service menu or how to price each treatment.', 'You end up searching "wood therapy abdomen protocol" the night before a session.'];
const tomes = [['VOLUME 1', 'Fundamentals, Anatomy and Tools', 'The scientific and technical base: history, tissue anatomy, the function of every tool, golden rules and a universal 60-minute base protocol.'], ['VOLUME 2', 'Body Sculpting and Aesthetics', 'Protocols for abdomen, flanks, legs, saddlebags and glutes with order, timing, pressure and lymphatic closing. Includes measuring and progress photography.'], ['VOLUME 3', 'Therapeutic Wood Therapy', 'Myofascial release with wood, protocols for cervical and dorsal tension, lower back, trigger points and post-workout athletes.'], ['VOLUME 4', 'Lymphatic Drainage and Postpartum', 'Drainage with wood, fluid retention and a postpartum protocol with safety criteria, diastasis, a 12-session plan and consent forms.'], ['VOLUME 5', 'Session and Program Design', 'Timelines for 30, 45, 60 and 90 minutes, 8 and 12-session programs, service menu, suggested pricing and profitability.'], ['VOLUME 6', 'Marketing, Business and Management', 'A 7-day launch, social media, monthly content, admin, client forms and an action plan for your first 90 days.']];
const bonuses = [{
  title: 'Express Map of Protocols by Goal',
  value: '$19',
  description: 'Find in seconds which protocol to use based on your client goal. Includes a quick table, a 3-question selector and a mobile version.',
  image: 'https://cdn.magicpatterns.com/uploads/3mYTRrP11v2aoNiCh9arnW/bono-1.webp'
}, {
  title: 'Pro Safety and Session Preparation Checklist',
  value: '$19',
  description: 'Prepare every session with a safety traffic light, a pressure scale and a professional welcome script.',
  image: 'https://cdn.magicpatterns.com/uploads/sseNyuVoZqsN4YZPpuGvEh/Bono-2.webp'
}, {
  title: '21-Day Agenda to Launch Your Wood Therapy Service',
  value: '$19',
  description: 'Organize, publish and get your service ready to sell with simple 10 to 30-minute daily tasks.',
  image: 'https://cdn.magicpatterns.com/uploads/tKyTbsCVRJiUQw1zbP78Rk/Bono-3.webp'
}, {
  title: 'Professional Client Form Pack for Wellness Clients',
  value: '$19',
  description: 'Intake form, measurement log, subjective progress, consent form and post-session recommendations.',
  image: 'https://cdn.magicpatterns.com/uploads/jgTohn8NNVVzGRPj4Cjhci/bono-4.webp'
}, {
  title: 'WhatsApp and Instagram Scripts to Sell Wood Therapy',
  value: '$21',
  description: '25 scripts, objection responses, captions and story copy ready to copy and paste.',
  image: 'https://cdn.magicpatterns.com/uploads/fQANU1c56s8tPdmKUsdgNg/bono-5.webp'
}];
export function Features() {
  return <div className="w-full bg-white" data-id="element-5" data-mp="1ryuzv0a3z8fe">
      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-6" data-mp="1rxtbju430pfq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-7" data-mp="lj275gfr2mgy">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-8" data-mp="lgfzlgsv06yq">
            Recognize the problem
          </p>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-brand-900 md:text-4xl" data-id="element-9" data-mp="24flzxvw1vjhb">
            If you are a wellness professional, you are probably dealing with
            some of these problems
          </h2>
        </div>
        <div className="mt-9 grid gap-3 md:grid-cols-2" data-id="element-10" data-mp="1vgqqmaxplt9s">
          {painPoints.map(point => <div key={point} className="flex gap-3 rounded-xl border border-brand-100 bg-cream p-4" data-id="element-11" data-mp="1zhu9z7eyu7fr">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-12" data-mp="2s5q2dzxi5d6q" />
              <p className="text-sm font-medium leading-relaxed text-gray-700" data-id="element-13" data-mp="2e4vtlg6jla7j">
                {point}
              </p>
            </div>)}
        </div>
        <p className="mt-10 text-center text-2xl font-black text-brand-600 md:text-3xl" data-id="element-14" data-mp="12r1qs0wqjz9r">
          What if all of this were already done for you?
        </p>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-15" data-mp="17ns6uo8jiuv6">
        <div className="mx-auto max-w-6xl text-center" data-id="element-16" data-mp="z79o14fe73rg">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-800 px-4 py-2 text-xs font-bold tracking-wide text-accent" data-id="element-17" data-mp="v7siyc3vo8mt">
            <TrophyIcon className="h-4 w-4" data-id="element-18" data-mp="196igfsum0abp" /> THE MOST COMPLETE SYSTEM
            AVAILABLE
          </div>
          <h2 className="mt-5 text-3xl font-black md:text-5xl" data-id="element-19" data-mp="148qlepyo483a">
            WOOD THERAPY PRO MEGAPACK™
          </h2>
          <p className="mt-3 text-lg font-semibold text-brand-100 md:text-2xl" data-id="element-20" data-mp="gg0bsne8m0w6">
            6 Volumes + 5 Bonuses — From the first contact to a complete
            business system
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-gray-300 md:text-base" data-id="element-21" data-mp="q9zcdhynxcm0">
            More than 300 pages of ready protocols, client forms, scripts and
            professional management material — all done for you.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-22" data-mp="3ox4uixmd8c28">
            {[['300+', 'pages', FileTextIcon], ['20+', 'ready protocols', BookOpenIcon], ['8', 'tools mastered', TrophyIcon], ['Forms', 'printable included', CheckCircle2Icon]].map(([value, label, Icon]) => {
            const StatIcon = Icon as typeof FileTextIcon;
            return <div key={label as string} className="rounded-xl bg-brand-800/70 p-4" data-id="element-23" data-mp="26oj01dwfk734">
                  <StatIcon className="mx-auto h-6 w-6 text-accent" data-id="element-24" data-mp="1euqtx29gw1xq" />
                  <p className="mt-2 font-black" data-id="element-25" data-mp="1iwu4loobb2hy">{value}</p>
                  <p className="text-xs text-brand-100" data-id="element-26" data-mp="1ivanxwyqupfn">{label}</p>
                </div>;
          })}
          </div>
          <p className="mt-7 text-sm font-medium leading-loose text-brand-100" data-id="element-27" data-mp="1ntkkoc049y3d">
            Fundamentals · Body sculpting · Therapeutic work · Drainage and
            postpartum · Sessions and programs · Business and management
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-28" data-mp="39eiyj9wudpvx">
        <div className="text-center" data-id="element-29" data-mp="34gz5v4zedakg">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-30" data-mp="34i0u6b5fbtk4">
            Your reference library
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-31" data-mp="2vnvzthr2zzzu">
            The 6 Complete Volumes
          </h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-32" data-mp="2qq474lim49ul">
          {tomes.map(([number, title, description], index) => <article key={number} className={`rounded-2xl border p-6 ${index === 2 ? 'border-accent bg-accent/5' : 'border-brand-100 bg-white'}`} data-id="element-33" data-mp="2lrj1u7oi6zza" data-mpi={index}>
              <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-34" data-mp="2cql1q0h6rclz">
                {number}
                {index === 2 ? ' · THE VOLUME THAT SETS YOU APART' : ''}
              </p>
              <h3 className="mt-2 text-xl font-black text-brand-900" data-id="element-35" data-mp="ay6gosjchs1c">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-gray-600" data-id="element-36" data-mp="u8iuqq6gk40g">
                {description}
              </p>
            </article>)}
        </div>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 rounded-xl border border-brand-100 bg-cream p-5 text-xs font-semibold text-brand-800" data-id="element-37" data-mp="kfk30zfnzxcm">
          {['Complete protocols ready to use', 'Printable and digital client forms', 'Step-by-step checklists', 'Material you can hand to clients', 'Readable from tablet or phone'].map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-38" data-mp="1ju45l313h2y">
              <CheckCircle2Icon className="h-4 w-4 text-brand-500" data-id="element-39" data-mp="6h3z1g96sky6" />
              {item}
            </span>)}
        </div>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6 md:py-20" data-id="element-40" data-mp="20ubmunyqvwab">
        <div className="mx-auto max-w-5xl" data-id="element-41" data-mp="20sipy0dxoqfi">
          <div className="text-center" data-id="element-42" data-mp="2axqr9braqovv">
            <p className="text-sm font-bold text-brand-600" data-id="element-43" data-mp="2ays3vknynjfp">
              Included at no extra cost — Total value: $97 →{' '}
              <span className="text-brand-900" data-id="element-44" data-mp="2jqtzn5n34bjn">FREE with your MegaPack</span>
            </p>
            <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-45" data-mp="2jsoouw5e2ptj">
              The 5 Strategic Bonuses
            </h2>
          </div>
          <div className="mt-9 space-y-4" data-id="element-46" data-mp="2tnyr9kzp8z7u">
            {bonuses.map((bonus, index) => <article key={bonus.title} className="flex gap-4 rounded-xl border border-brand-100 bg-white p-4 sm:gap-5 sm:p-5" data-id="element-47" data-mp="2oqq7xh2tep50" data-mpi={index}>
                <img src={bonus.image} alt={`Cover of the bonus: ${bonus.title}`} className="h-28 w-20 shrink-0 rounded-md border border-brand-100 object-cover shadow-sm sm:h-36 sm:w-24" data-id="element-48" data-mp="2yoe2o70f7wn6" />
                <div className="min-w-0 py-0.5" data-id="element-49" data-mp="14bwix9esjena">
                  <div className="flex items-center gap-2" data-id="element-50" data-mp="17y9h0izvfw23">
                    <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent/15" data-id="element-51" data-mp="17vetgilk9v4g">
                      <GiftIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-52" data-mp="yx1uszamqlod" />
                    </div>
                    <p className="text-xs font-bold text-brand-600" data-id="element-53" data-mp="u032mmaj0ost">
                      BONUS 0{index + 1} ·{' '}
                      <span className="text-gray-400 line-through" data-id="element-54" data-mp="1mmno564bm6og">
                        {bonus.value}
                      </span>{' '}
                      · FREE
                    </p>
                  </div>
                  <h3 className="mt-2 text-base font-black text-brand-900 sm:text-lg" data-id="element-55" data-mp="1cxcjpwsdpq6w">
                    {bonus.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-gray-600" data-id="element-56" data-mp="2adt4dme6b0za">
                    {bonus.description}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </section>
    </div>;
}